import clsx from 'clsx';

import { Icon } from '../../components';
import { useAppContext } from '../../shared';

type CollapserProps = {};

export const Collapser: React.FC<CollapserProps> = () => {
  const { collapsed, setCollapsed } = useAppContext();

  return (
    <Icon
      onClick={() => setCollapsed(c => !c)}
      icon={!collapsed ? 'menu_on' : 'menu_off'}
      className={clsx(
        collapsed ? 'left-[2rem] top-[2rem]' : 'left-[28rem] top-[2.8rem]',
        'absolute transition-all',
        'text-title text-text',
        'opacity-80 hover:opacity-100 cursor-pointer'
      )}
    />
  );
};
